<template>
  <div class="app app-contents columns">
    <div v-if="loading" class="spinner-container">
      <woot-loading-state message="Carregando..." />
    </div>
    <iframe
      v-else
      ref="typebotIframe"
      :src="url"
      height="100%"
      scrolling="true"
      width="100%"
      frameborder="0"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import CryptoJS from 'crypto-js';
const ref_key = 'b6aab55e7d96054bddb58cf663d1c5c7';

export default {
  components: {},
  data() {
    return {
      loading: true,
      integration: null,
      url: null,
    };
  },
  mounted() {},
  async created() {
    await this.$store.dispatch('integrations/get').then(() => {
      const integration = this.$store.getters['integrations/getIntegration'](
        'wise'
      );

      const settings = integration.hooks[0].settings;
      this.integration = integration.hooks[0].settings;

      const payload = {
        email: settings.email,
        password: settings.password,
      };

      const encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(payload),
        ref_key
      ).toString();

      const encoded = encodeURIComponent(encrypted);

      this.url = `${settings.url}?omni=true&credentials=${encoded}`;

      setTimeout(() => {
        this.loading = false;
      }, 5000);
    });
    this.loadData();
  },

  methods: {
    ...mapActions(['loadData']),
  },
};
</script>

<style scoped>
.app {
  display: flex;
  margin: 0;
  padding: 0;
  height: 100vh;
  overflow: hidden;
}
.page-container {
  flex: 1;
  height: 100vh;
  overflow-y: auto;
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  width: 100%;
  flex-direction: column;
}

.spinner {
  width: 32px;
  height: 32px;
  /* border: 4px solid #ccc;
  border-top: 4px solid #333;
  border-radius: 50%; */
  animation: spin 0.8s linear infinite;
  /* margin-top: 10px; */
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
